import dispatcher from "./../Dispatcher/Dispatcher";
import { EventEmitter } from "events";
import access_controlConstants from "./../Constants/Access_ControlConstants";
import Access_ControlConstants from "./../Constants/Access_ControlConstants";

let loginInfo = {};
let loginError = null;
let forgotPassword = null;
let changePassword = null;
let equListToken = null;
let addAnlageChild = null;
let anlageChild = null;
let deleteAnlageChild = null;
let sessionExpiredRes = null;
let anlageAttributeBulk = null;
let anlageAttributeBulkUpdateResult = null;
let anlageAttributeBulkDeleteResult = null;
let anlageLastinspection = null;
let publicAccessUser = null;
let localizationMessages = null;
let bulkStatusUpdate = null;
let passwordValidationRes = null;
class Access_ControlStore extends EventEmitter {
  emitChange(eventName) {
    this.emit(eventName);
  }

  getLoginInfo() {
    return loginInfo;
  }

  setloginInfo(result) {
    loginInfo = result;
  }

  getLoginError() {
    return loginError;
  }

  setloginError(result) {
    loginError = result;
  }

  getForgotPassword() {
    return forgotPassword;
  }

  setForgotPassword(res) {
    forgotPassword = res;
  }

  getChangePassword() {
    return changePassword;
  }
  setChangePassword(res) {
    changePassword = res;
  }

  getEquListToken() {
    return equListToken;
  }

  setEquListToken(res) {
    equListToken = res;
  }
  getAddAnlageChild() {
    return addAnlageChild;
  }

  setAddAnlageChild(res) {
    addAnlageChild = res;
  }

  getAnlageChild() {
    return anlageChild;
  }

  setAnlageChild(res) {
    anlageChild = res;
  }

  getDeleteAnlageChild() {
    return deleteAnlageChild;
  }

  setDeleteAnlageChild(res) {
    deleteAnlageChild = res;
  }

  setSessionExpiredMessage(res) {
    sessionExpiredRes = res;
  }

  getSessionExpiredMessage() {
    return sessionExpiredRes;
  }

  getAnlageAttributeBulkDetails() {
    return anlageAttributeBulk;
  }

  setAnlageAttributeBulkDetails(result) {
    anlageAttributeBulk = result;
  }

  getUpdateAnlageAttributeBulkResult() {
    return anlageAttributeBulkUpdateResult;
  }

  setUpdateAnlageAttributeBulkResul(result) {
    anlageAttributeBulkUpdateResult = result;
  }
  getDeletBulkDetailsResult() {
    return anlageAttributeBulkDeleteResult;
  }

  setDeletBulkDetailsBulkResul(result) {
    anlageAttributeBulkDeleteResult = result;
  }

  getAnlageLastInspectionDetails() {
    return anlageLastinspection;
  }

  setAnlageLastInspectionDetails(result) {
    anlageLastinspection = result;
  }

  getUserInfoPublicAccess() {
    return publicAccessUser;
  }

  setUserInfoPublicAccess(result) {
    publicAccessUser = result;
  }

  getLocalizationMessages() {
    return localizationMessages;
  }

  setLocalizationMessages(result) {
    localizationMessages = result;
  }

  getUpdateStatusBulkResult() {
    return bulkStatusUpdate;
  }

  setUpdateStatusBulkResul(result) {
    bulkStatusUpdate = result;
  }

  getPasswordValidationResult() {
    return passwordValidationRes;
  }

  setPasswordValidationResult(result) {
    passwordValidationRes = result;
  }

  addChangeListener(eventName, callback) {
    this.on(eventName, callback);
  }

  removeChangeListener(eventName, callback) {
    this.removeListener(eventName, callback);
  }

  handleCallback(action) {
    switch (action.type) {
      case access_controlConstants.LOGIN_SUCCESS:
        this.setloginInfo(action.result);
        break;
      case access_controlConstants.LOGIN_FAILURE:
        this.setloginError(action.result);
        break;
      case access_controlConstants.LOGOUT_SUCCESS:
        this.setloginInfo(null);
        break;
      case access_controlConstants.FORGET_PASSWORD_SUCCESS:
        this.setForgotPassword(action.result);
        break;
      case access_controlConstants.FORGET_PASSWORD_FAILURE:
        this.setForgotPassword(action.result);
        break;
      case access_controlConstants.CHANGE_PASSWORD_SUCCESS:
        this.setChangePassword(action.result);
        break;
      case access_controlConstants.CHANGE_PASSWORD_FAILURE:
        this.setChangePassword(action.result);
        break;
      case access_controlConstants.GET_EQI_LIST_TOKEN_SUCCESS:
        this.setEquListToken(action.result);
        break;
      case access_controlConstants.GET_EQI_LIST_TOKEN_FAILURE:
        this.setEquListToken(action.result);
        break;
      case access_controlConstants.ADD_ANLAGE_CHILD_SUCCESS:
        this.setAddAnlageChild(action.result);
        break;
      case access_controlConstants.ADD_ANLAGE_CHILD_FAILURE:
        this.setAddAnlageChild(action.result);
        break;
      case Access_ControlConstants.GET_ANLAGE_CHILDREN_SUCCESS:
        this.setAnlageChild(action.result);
        break;
      case Access_ControlConstants.GET_ANLAGE_CHILDREN_FAILURE:
        this.setAnlageChild(action.result);
        break;
      case Access_ControlConstants.DELETE_ANLAGE_CHILD_SUCCESS:
        this.setDeleteAnlageChild(action.result);
        break;
      case Access_ControlConstants.DELETE_ANLAGE_CHILD_FAILURE:
        this.setDeleteAnlageChild(action.result);
        break;
      case Access_ControlConstants.SESSION_EXPIRED:
        this.setSessionExpiredMessage(action.result);
        break;
      case Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_SUCCESS:
        this.setAnlageAttributeBulkDetails(action.result);
        break;
      case Access_ControlConstants.GET_ANLAGE_ATTRIBUTE_BULK_FAILURE:
        this.setAnlageAttributeBulkDetails(action.result);
        break;
      case Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_SUCCESS:
        this.setUpdateAnlageAttributeBulkResul(action.result);
        break;
      case Access_ControlConstants.SAVEANDUPDATE_ANLAGE_ATTRIBUTE_BULK_FAILURE:
        this.setUpdateAnlageAttributeBulkResul(action.result);
        break;
      case Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_SUCCESS:
        this.setAnlageLastInspectionDetails(action.result);
        break;
      case Access_ControlConstants.GET_ANLAGE_LAST_INSPECTION_FAILURE:
        this.setAnlageLastInspectionDetails(action.result);
        break;
      case Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_SUCCESS:
        this.setDeletBulkDetailsBulkResul(action.result);
        break;
      case Access_ControlConstants.BULK_DELETE_ANLAGE_ATTRIBUTE_FAILURE:
        this.setDeletBulkDetailsBulkResul(action.result);
        break;
      case access_controlConstants.LOGIN_PUBLIC_ACCESS_SUCCESS:
        this.setUserInfoPublicAccess(action.result);
        break;
      case access_controlConstants.LOGIN_PUBLIC_ACCESS_FAILURE:
        this.setUserInfoPublicAccess(action.result);
        break;
      case Access_ControlConstants.GET_LOCALIZATION_MESSAGE_SUCCESS:
        this.setLocalizationMessages(action.result);
        break;
      case Access_ControlConstants.GET_LOCALIZATION_MESSAGE_FAILURE:
        this.setLocalizationMessages(action.result);
        break;
      case Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_SUCCESS:
        this.setUpdateStatusBulkResul(action.result);
        break;
      case Access_ControlConstants.BULK_UPDATE_ANLAGE_STATUS_FAILURE:
        this.setUpdateStatusBulkResul(action.result);
        break;
      case Access_ControlConstants.PASSWORD_VALIDATION_SUCCESS:
        this.setPasswordValidationResult(action.result);
        break;
      case Access_ControlConstants.PASSWORD_VALIDATION_FAILURE:
        this.setPasswordValidationResult(action.result);
        break;
      default:
        break;
    }
    this.emitChange(action.type);
    return true;
  }
}
const access_ControlStore = new Access_ControlStore();
dispatcher.register(
  access_ControlStore.handleCallback.bind(access_ControlStore),
);
export default access_ControlStore;
